import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "universal-cookie";

const cookie = new Cookies
const token = cookie.get('token')

export const gemoApi = createApi({
  reducerPath: "reqres/gemo",
  tagTypes: ["gemo"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://oncomed.up.railway.app/",
    prepareHeaders: (headers, { getState }) => {
      // const token = getState().authSlice.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getArizaNotFinished: build.query({
      query: (page = 0) => `neurona/complaint?pageNumber=${page}`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "gemo",
                id,
              })),
              { type: "gemo", id: "LIST" },
            ]
          : [{ type: "gemo", id: "LIST" }],
    }),
    getArizaFinished: build.query({
      query: (page = 0) => `neurona/complaint/finished?pageNumber=${page}`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "gemo",
                id,
              })),
              { type: "gemo", id: "LIST" },
            ]
          : [{ type: "gemo", id: "LIST" }],
    }),
    getAll: build.query({
      query: () => `neurona/complaint/all?pageNumber=0`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "gemo",
                id,
              })),
              { type: "gemo", id: "LIST" },
            ]
          : [{ type: "gemo", id: "LIST" }],
    }),
    check: build.mutation({
      query: (body) => ({
        url: `oncomed/complaint/client`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "onco", id: "LIST" }],
    }),
    sendMsg: build.mutation({
      query: (body) => ({
        url: `neurona/complaint`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "gemo", id: "LIST" }],
    }),
    finished: build.mutation({
      query: (body) => ({
        url: `neurona/complaint/finished`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "gemo", id: "LIST" }],
    }),
  }),
});

export const {
  useSendMsgMutation,
  useFinishedMutation,
  useGetArizaFinishedQuery,
  useGetArizaNotFinishedQuery,
  useGetAllQuery,
  useCheckMutation
} = gemoApi;
